// src/theme/z-index/index.ts
var zIndex = {
  modal: 1300
};
var z_index_default = zIndex;

export { z_index_default as default };
